import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

// Interfaaces
import { IComponent } from '../../../share/interfaces';
// Services
import * as srv from '../../../share/services';
import { environment } from '../../../../environments/environment';
import { environmentBase } from '../../../../environments/environment.base';

@Component({
	selector: 'app-topbanner',
	templateUrl: './topbanner.component.html',
	styleUrls: ['./topbanner.component.scss']
})
export class TopbannerComponent implements IComponent, OnInit, OnDestroy {
	// Implement IComponent
	name = 'TopbannerComponent';
	subscriptions: Subscription[] = [];
	showMenu = false;
	pacedlogolink: string;
	showSearch = false;
	// implement local variables
	// *
	constructor(
		public userSrv: srv.UserService,
		private _helperSrv: srv.HelperService,
		private _logSrv: srv.LogService
	) { }

	ngOnInit() {
		this.initStylesForLoginHeader();
		this.showSearch = false;
		this.showMenu = false;
		const $this = this;
		this.pacedlogolink = (environment.Evn !== 'production' ? environment.base.PACEDHometest : environment.base.PACEDHomeprod);
		$(document).find('div').not('.search').not('.member').click(function (e) {
			if (e.target.id !== 'searchMembership' && e.target.id !== 'memberSearchbtn') {
				e.stopPropagation();
				if ($this.showMenu === true) {
					$this.showMenu = false;
					$('.member .menu').slideUp();
				}
				if ($this.showSearch === true) {
					$this.showSearch = false;
					$('.search .menu').animate({ width: 'toggle' }, 100);
				}
			}
		});
	}

	initStylesForLoginHeader() {
		$(".loginTool").click(function () {
			$(".loginToolopen").slideToggle('fast');
			$(".searchToolopen").hide();
		});

		$(".mSearch").click(function () {
			$(".searchToolopen").slideToggle('fast');
			$(".loginToolopen").hide();
		});
	}

	ngOnDestroy() {
		this._unsuscribe();
		delete this.subscriptions;
	}

	OnApplicationsClicked() {
		this._logSrv.Debug(this.name, ['OnApplicationsClicked', this.userSrv.Data]);
		this._helperSrv.goToApplications(this.userSrv.Data.contact.Id);
	}

	OnSignOut() {
		this._logSrv.Debug(this.name, ['OnSignOut']);
		this.userSrv.signOut(this.name);
	}

	goToMyAccount() {
		// this._loaderSrv.SetLoading(this.name, true);
		// this._router.navigate(['/membership/dashboard']);
		this._helperSrv.goToMyAccount();

	}

	private _unsuscribe() {
		this.subscriptions.forEach(s => {
			s.unsubscribe();
		});
	}


	search(searchtext: string) {
		window.location.href = 'https://www.acep.org/search.aspx?searchtext=' + searchtext;
		return false;
	}

	toggleMemberMenu(e) {
		e.stopPropagation();
		if (this.showSearch === true) {
			this.showSearch = false;
			$('.search .menu').animate({ width: 'toggle' }, 200);
		}
		if (this.showMenu === false) {
			this.showMenu = true;
			$('.member .menu').slideDown();
		} else {
			this.showMenu = false;
			$('.member .menu').slideUp();
		}
	}

	toggleSearchMenu(e) {
		e.stopPropagation();
		if (this.showMenu === true) {
			this.showMenu = false;
			$('.member .menu').slideUp();
		}
		if (this.showSearch === false) {
			this.showSearch = true;
			$('.search .menu').animate({ width: 'toggle' }, 200);
		} else {
			this.showSearch = false;
			$('.search .menu').animate({ width: 'toggle' }, 200);
		}
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/topbanner/topbanner.component.ts